import React from "react";
import { Route, Switch } from "react-router-dom";
// No logged
import App from "../App";
import LoginPage from "../screens/LoginScreen";
import ResetPasswordPage from "../screens/ResetPasswordPage";
// SETTINGS
import Settings from "../screens/settings/Show";
// SIDEBAR
import Sidebar from "Components/sidebar/Sidebar";
// ORDERS
import OrderNew from "../screens/orders/New";
import OrderShow from "../screens/orders/Show";
// OTHERS
import ServerMissing from "Components/ServerMissing";
import NotFound from "Components/NotFound";
import qs from "query-string";

export default (props) => (
  <div>
    <Route exact path="/manteinance" component={ServerMissing} />
    <Route exact path="/login" component={LoginPage} />
    <Route exact path="/users/:userCode/reset_password" component={ResetPasswordPage} />

    <Route
      render={(routerProps) => {
        const p = { ...props, ...routerProps };
        // add location.query to the props
        p.location.query = qs.parse(p.location.search);

        return (
          <Sidebar {...p}>
            <Switch>
              <Route exact path="/" component={OrderNew} />
              <Route exact path="/account" component={Settings} />
              <Route exact path="/orders" component={OrderShow} />
              <Route exact path="/orders/new" component={OrderNew} />
              <Route exact path="*" component={NotFound} />
            </Switch>
          </Sidebar>
        );
      }}
    />
  </div>
);
